import { Component, Input, OnInit } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { LanguageMatchRepoService } from '@client/app/services/api/language-match-repo/language-match-repo.service';

@Component({
    selector: 'page-details-section-qa-language-match',
    standalone: false,
    templateUrl: './page-details-section-qa-language-match.component.html',
})
export class PageDetailsSectionQaLanguageMatchComponent implements OnInit {
    @Input() pageObj: any = {};

    languageMatchData: any = null;
    isLoading = false;
    domain: any;

    constructor (
        private sessionService: SessionService,
        private languageMatchRepoService: LanguageMatchRepoService,
    ) {}

    ngOnInit (): void {
        this.domain = this.sessionService.domain;
        this.loadLanguageMatchData();
    }

    get isLanguageAttributeEnabled (): boolean {
        return this.sessionService.domain?.scan?.use_lang_attribute === true;
    }

    private loadLanguageMatchData (): void {
        if (!this.pageObj || !this.pageObj.id) {
            return;
        }

        this.isLoading = true;
        this.languageMatchRepoService.page(this.pageObj.id).then((data) => {
            this.languageMatchData = data || null;
            this.isLoading = false;
        }).catch((error) => {
            // Error loading language match data
            this.languageMatchData = null;
            this.isLoading = false;
        });
    }
}

